import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import FeatureCheckbox from './Inputs/Checkboxes/FeatureCheckbox';

import { MdOutlineExpandMore, MdKeyboardArrowRight } from 'react-icons/md'
import './ProductFeature.css'

const ProductFeature = ({ feature, setFeatures, features }) => {
  const [showContent, setShowContent] = useState(true);

  const isChecked = (name, value) => {
    var feature = features.find(x => x.name == name)
    if (feature) {
      if (feature.values.find(x => x == value)) {
        return true
      }
      return false
    }

    return false;
  }

  const betterClickHandler = (name, value) => {
    if (!features.find(x => x.name == name)) {
      setFeatures(prev => [...prev, { "index": "", "name": name, "category": "", "values": [value] }])
    } else {
      var featuresList = features.filter(x => x.name !== name)
      var feature = features.find(x => x.name == name)

      var featureValues = feature.values.filter(x => x !== value)

      if (!feature.values.find(x => x == value)) {
        setFeatures([...featuresList, { "index": "", "name": name, "category": "", "values": [...feature.values, value] }])
      } else {
        setFeatures([...featuresList, { "index": "", "name": name, "category": "", "values": featureValues }])
      }

      if (featureValues.length == 0) {
        setFeatures(featuresList)
      }

    }
  }

  const capitalizeFirstLowercaseRest = str => {
    return (
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    );
  };

  return (<div className='feature'>
    <div className='feature-name row' onClick={() => setShowContent(!showContent)}>
      <div className='col'>{capitalizeFirstLowercaseRest(feature.name)}</div>
      {/* <div className='col'>{feature.name}</div> */}
      <div className='col-auto expandMore-icon' >{showContent ? <MdOutlineExpandMore size={25} /> : <MdKeyboardArrowRight size={25} />}</div>
    </div>
    <div className={showContent ? 'feature-values show' : 'feature-values'}>
      {feature.values.map(value => {
        return <FeatureCheckbox feature={{ name: feature.name, value: value }} handleClick={betterClickHandler} isChecked={() => isChecked(feature.name, value)} />
      })}
    </div>

  </div>

  )
}



export default ProductFeature